import apiRequest from './apiRequest';

export default async function deleteFavorite(
  jobID: string,
  animationNumber: number,
) {
  return await apiRequest(
    'mogen-orchestration',
    `/jobs/${jobID}/favorite?animationNumber=${animationNumber}`,
    {
      method: 'DELETE',
    },
  );
}
